import { Component, Input, OnInit } from "@angular/core";
import { ModalController, NavController } from "@ionic/angular";
import { AppService } from "src/app/_services/app.service";

@Component({
  selector: "app-work-finished-modal",
  templateUrl: "./work-finished-modal.component.html",
  styleUrls: ["./work-finished-modal.component.scss"],
  standalone: false,
})
export class WorkFinishedModalComponent implements OnInit {
  @Input() role: string = "";
  constructor(
    private nav: NavController,
    private appService: AppService,
    private modalController: ModalController
  ) {}

  ngOnInit() {}

  closeModal() {
    this.modalController.dismiss();
    this.appService.dispatchModal("WORK_FINISHED_MODAL", false);
    // setTimeout(() => {
    //   this.nav.pop();
    // }, 100);
  }
}
